import { css } from 'linaria';

export const cabinetGallerySectionTabs = css`
  && {
    margin-bottom: 32px;

    @media (--only-mobile) {
      margin-bottom: 24px;
    }
  }
`;


export const cabinetGalleryGrid = css`
  && {
    display: grid;
    grid-gap: 24px;
    width: 100%;
    padding: 0;
    margin-bottom: 32px;
    list-style: none;

    li {
      cursor: pointer;
    }

    @media (--from-tablet) {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 380px auto;

      :nth-child(1) {
        grid-row: auto / span 2;
      }
    }

    @media (--only-mobile) {
      grid-template-columns: 1fr;
      grid-template-rows: 288px auto;
      margin-bottom: 24px;
    }
  }
`;

export const cabinetGalleryImageWrapper = css`
  width: 100%;
  height: 380px;

  &:nth-of-type(1) {
    height: 784px;

    @media (--from-tablet) {
      grid-row-start: span 2;
    }

    @media (--only-mobile) {
      height: 288px;
    }
  }
`;
